import {
  MessageCircle,
  CalendarDays,
  FolderClosed,
  Images,
  ChartColumn,
  Lightbulb,
  NotebookPen,
  Music2,
  Settings,
} from 'lucide-react';

/**
 * 应用注册表：桌面图标与路由都由这里驱动。
 * eg 是初始界面，其余应用都与 eg 平级：各自占据一个顶层路由，互不嵌套。
 * 新增一个功能页 = 在这里加一条 + 在 App.js 里挂上同名路由。
 */
export const APPS = [
  {
    id: 'messages',
    name: '消息',
    path: '/messages',
    icon: MessageCircle,
    tint: '#7aa2ff',
    description: '消息与通知会汇总在这里。',
  },
  {
    id: 'calendar',
    name: '日程',
    path: '/calendar',
    icon: CalendarDays,
    tint: '#a78bfa',
    description: '安排今天，以及之后的每一天。',
  },
  {
    id: 'files',
    name: '文件',
    path: '/files',
    icon: FolderClosed,
    tint: '#f0b429',
    description: '项目文档与资源集中存放。',
  },
  {
    id: 'photos',
    name: '相册',
    path: '/photos',
    icon: Images,
    tint: '#4ec9a5',
    description: '按时间与主题浏览图片。',
  },
  {
    id: 'analytics',
    name: '数据',
    path: '/analytics',
    icon: ChartColumn,
    tint: '#5fc8e8',
    description: '关键指标的概览与趋势。',
  },
  {
    id: 'esp',
    name: 'ESP',
    path: '/esp',
    icon: Lightbulb,
    tint: '#ffcf6b',
    description: '光照数据趋势。',
  },
  {
    id: 'notes',
    name: '备忘',
    path: '/notes',
    icon: NotebookPen,
    tint: '#f08bb4',
    description: '随手记录想法与待办。',
  },
  {
    id: 'music',
    name: '音乐',
    path: '/music',
    icon: Music2,
    tint: '#ff9f6b',
    description: '专注时的一点背景声。',
  },
  {
    // 设置是例外：后续负责壁纸等桌面管理
    id: 'settings',
    name: '设置',
    path: '/settings',
    icon: Settings,
    tint: '#a8b3c4',
    description: '壁纸、外观与偏好设置。',
  },
];

export const getAppById = (id) => APPS.find((app) => app.id === id);
